<div class="machine-inventory-view-container">
  <app-analytics-card [title]="'ANALYTICS.MACHINE_INVENTORY' | translate" [exportable]="true">
    <app-analytics-export-button
      export-button
      [isExporting]="isExporting"
      [filters]="filters"
      (exportFormat)="onExportFormatSelected($event, 'machine-inventory')"
    >
    </app-analytics-export-button>

    <app-analytics-widget [query]="'machine-inventory'" [paginable]="true" [pageSize]="15" [filters]="filters">
      <ng-template
        let-result
        let-totalPages="totalPages"
        let-currentPage="currentPage"
        let-pageSize="pageSize"
        let-onPageChange="onPageChange"
        let-onSizeChange="onSizeChange"
      >
        @if (result && result.rows && result.rows.length) {
          <div class="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>{{ 'ANALYTICS.PRODUCT_ID' | translate }}</th>
                  <th>{{ 'ANALYTICS.PRODUCT_NAME' | translate }}</th>
                  <th>{{ 'ANALYTICS.MACHINE_TYPE' | translate }}</th>
                  <th>{{ 'ANALYTICS.TRAY_ID' | translate }}</th>
                  <th>{{ 'ANALYTICS.QUANTITY' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of result.rows; track row; let i = $index) {
                  <tr [ngClass]="i % 2 === 1 ? 'odd' : ''">
                    <td [attr.data-label]="'ANALYTICS.PRODUCT_ID' | translate">{{ row.idProduct }}</td>
                    <td [attr.data-label]="'ANALYTICS.PRODUCT_NAME' | translate" class="product-name-cell">
                      <span class="truncate-text" [appTooltip]="row.name" position="top">{{ row.name }}</span>
                    </td>
                    <td [attr.data-label]="'ANALYTICS.MACHINE_TYPE' | translate">{{ row.machineType }}</td>
                    <td [attr.data-label]="'ANALYTICS.TRAY_ID' | translate">{{ row.idTray }}</td>
                    <td [attr.data-label]="'ANALYTICS.QUANTITY' | translate">{{ row.quantity }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (result && result.rows && result.rows.length) {
          <app-analytics-pagination-controller
            [totalPages]="totalPages"
            [currentPage]="currentPage"
            (pageChange)="onPageChange($event)"
          >
          </app-analytics-pagination-controller>
        }
      </ng-template>
    </app-analytics-widget>
  </app-analytics-card>
</div>
